import { Box, Text, Flex, Button } from '@chakra-ui/react';

import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import { configFile } from '@/config';

import DesignPhone from '@/img/design-phone-locasty.png';
import { handleGTMClick } from '@/helpers/handleGTMClick';

export default function AdLocasty() {
  const { t } = useTranslation('common');

  return (
    <Box width="100%" position="relative" mt="76px">
      <Box position="absolute" top="-76px" left="50%" transform="translateX(-50%)">
        <Image src={DesignPhone} alt="Design Phone" />
      </Box>
      <Flex
        width="100%"
        flexDir="column"
        bgColor="#9D95F5"
        flexWrap="wrap"
        justifyContent="center"
        alignItems="center"
        boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)"
        borderRadius="8px"
        padding="120px 32px 32px 32px"
      >
        <Text
          lineHeight="32px"
          fontWeight="700"
          fontSize="24px"
          color={configFile.tertiaryAccentColor}
          textAlign="left"
          mb="16px"
        >
          {t('article.locasty.title')}
        </Text>
        <Text
          lineHeight="24px"
          fontWeight="400"
          fontSize="16px"
          color={configFile.tertiaryAccentColor}
          textAlign="left"
          mb="24px"
        >
          {t('article.locasty.text')}
        </Text>
        <Button
          id="blog_locasty_ad"
          onClick={(e) => handleGTMClick(e, () => window.open('https://locasty.com/pt', '_blank'))}
          aria-label="go to Locasty"
          w="100%"
          size="lg"
          color="#7367F0"
          bgColor={configFile.tertiaryAccentColor}
          _hover={{ bgColor: 'gray.100' }}
        >
          {t('article.locasty.button1')}
        </Button>
      </Flex>
    </Box>
  );
}
